import { BuyCreditsModal } from "@/components/credits/BuyCreditsModal";
import { createFileRoute, redirect } from "@tanstack/react-router";
import z from "zod";
import { Route as BoostRoute } from "./route";

const historyStateSchema = z
  .object({
    returnTo: z.string(),
    creditsNeededNow: z.number(),
    creditsNeededRestOfPeriod: z.number(),
  })
  .optional()
  .catch(undefined);

const parseHistoryState = (historyState: z.infer<typeof historyStateSchema>) =>
  historyStateSchema.parse(historyState);

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/boost/buy-credits",
)({
  staticData: {
    crumb: "Tilkøb credits",
    meta: {
      title: "Tilkøb credits",
    },
  },
  beforeLoad: ({ location }) => {
    const historyState = parseHistoryState(
      location.state.routeStates?.[Route.id],
    );

    if (!historyState) throw redirect({ to: ".." });

    const boostHistoryState = location.state.routeStates?.[BoostRoute.id];

    if (!boostHistoryState)
      throw redirect({
        from: Route.to,
        to: BoostRoute.to,
        replace: true,
      });

    return {
      parseHistoryState,
      useHistoryState: () => historyState,
      useBoostHistoryState: () => boostHistoryState,
    };
  },
  loader: () => ({
    showCampaignSetupSubStepper: false,
    showCampaignSetupBottomBar: false,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { useHistoryState, useBoostHistoryState } = Route.useRouteContext();
  const navigate = Route.useNavigate();

  const { returnTo, creditsNeededNow, creditsNeededRestOfPeriod } =
    useHistoryState();
  const boostHistoryState = useBoostHistoryState();

  return (
    <div className="-mt-8 flex grow flex-col pt-4 xl:-mt-14 xl:pt-7">
      <BuyCreditsModal
        neededCredits={creditsNeededRestOfPeriod}
        neededPrepaidCredits={creditsNeededNow}
        onClose={() =>
          navigate({
            to: returnTo,
            state: {
              routeStates: {
                [BoostRoute.id]: {
                  ...boostHistoryState,
                  autoSubmit: false,
                  skipCreditCheck: false,
                },
              },
            },
          })
        }
        onSuccess={() =>
          navigate({
            to: returnTo,
            state: {
              routeStates: {
                [BoostRoute.id]: {
                  ...boostHistoryState,
                  autoSubmit: true,
                  skipCreditCheck: true,
                },
              },
            },
          })
        }
        allowPrepaidCredits={true}
      />
    </div>
  );
}
